module.exports = __webpack_public_path__ + "static/img/17.95879ad0.png";